const DeadlineClockIcon = ({ color = 'currentColor' }) => {
  return (
    <svg
      width="21"
      height="19"
      viewBox="0 0 21 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9383 1.00008C6.84825 0.86008 2.67825 4.94008 2.67825 10.0001H0.888253C0.438253 10.0001 0.218253 10.5401 0.538253 10.8501L3.32825 13.6501C3.52825 13.8501 3.83825 13.8501 4.03825 13.6501L6.82825 10.8501C7.14825 10.5401 6.91825 10.0001 6.47825 10.0001H4.67825C4.67825 6.10008 7.85825 2.95008 11.7783 3.00008C15.4983 3.05008 18.6283 6.18008 18.6783 9.90008C18.7283 13.8101 15.5783 17.0001 11.6783 17.0001C10.0683 17.0001 8.57825 16.4501 7.39825 15.5201C6.99825 15.2101 6.43825 15.2401 6.07825 15.6001C5.65825 16.0301 5.68825 16.7301 6.15825 17.1001C7.67825 18.2901 9.59825 19.0001 11.6783 19.0001C16.7283 19.0001 20.8183 14.8301 20.6783 9.74008C20.5483 5.05008 16.6283 1.13008 11.9383 1.00008ZM11.4283 6.00008C11.0183 6.00008 10.6783 6.34008 10.6783 6.75008V10.4301C10.6783 10.7801 10.8683 11.1101 11.1683 11.2901L14.2883 13.1401C14.6483 13.3501 15.1083 13.2301 15.3183 12.8801C15.5283 12.5201 15.4083 12.0601 15.0583 11.8501L12.1783 10.1401V6.74008C12.1783 6.34008 11.8483 6.00008 11.4283 6.00008Z"
        fill={color}
      />
    </svg>
  );
};

export default DeadlineClockIcon;
